mainApp.directive('dnsSettings', function() {
    return {
        templateUrl: '/public/directives/dnsSettings.html',
        scope: {
            path: '@',
            model: '=',
            datamodified: "=",
            errors: "="
        },
        controller:  ['$scope', '$state', 'GeneralUtilsService', function($scope, $state, GeneralUtilsService) {


            // table of suffixes
            $scope.dnsSettingsSuffixesConfig = {
                id: "dnsSettingsSuffixes",
                dataURL : function(){
                    return null;
                },
                parseData : function() {
                    return $scope.model && $scope.model.dnsSettings && $scope.model.dnsSettings.suffixes ? $scope.model.dnsSettings.suffixes : [];
                },
                fields : [ {"label":"Suffix","noSort":true, "path":"suffix","template":"<span><input type='text' class='form-control' ng-model='item.suffix' /></span>"},
                           {"label":"Reorder","noSort":true, "path":"","template":"<div><span ng-click='tableConfig.switchLocation(item,-1)' class='glyphicon glyphicon-arrow-up'></span></div><div><span  ng-click='tableConfig.switchLocation(item,1)' class='glyphicon glyphicon-arrow-down'></span></div>"}
                ],
                actions : [],
                addAction : function(){
                    if (!$scope.model) {
                        return;
                    }
                    if (!$scope.model.dnsSettings) {
                        $scope.model.dnsSettings = {};
                    }
                    if (!$scope.model.dnsSettings.suffixes) {
                        $scope.model.dnsSettings.suffixes = [];
                        $scope.datamodified = new Date().getTime();
                    }
                    var newItem = {id:GeneralUtilsService.getRandomId(), suffix: ""};
                    $scope.model.dnsSettings.suffixes.push(newItem);
                },
                specialActions : [
                    {"func":function(selectedItems) {
                        selectedItems.forEach(function(item) {
                            for(var i = 0 ; i < $scope.model.dnsSettings.suffixes.length ; i++){
                                var modeSuffix = $scope.model.dnsSettings.suffixes[i];
                                if(modeSuffix.id === item.id){
                                    $scope.model.dnsSettings.suffixes.splice(i,1);
                                    break;
                                }
                            }
                        });
                    },"icon":"delete",tooltip:"Delete"}
                ],
                switchLocation : function(item, direction) {
                    for(var i = 0 ; i < $scope.model.dnsSettings.suffixes.length ; i++){
                        var modeSuffix = $scope.model.dnsSettings.suffixes[i];
                        if(modeSuffix.id === item.id){
                            $scope.dnsSettingsSuffixesConfig.swapText(i + direction, i);
                            break;
                        }
                    }
                },
                swapText : function (newPlace, oldPlace) {
                    if (newPlace >= 0 && newPlace <= $scope.model.dnsSettings.suffixes.length -1) {
                        var tmp = $scope.model.dnsSettings.suffixes[newPlace].suffix;
                        $scope.model.dnsSettings.suffixes[newPlace].suffix = $scope.model.dnsSettings.suffixes[oldPlace].suffix;
                        $scope.model.dnsSettings.suffixes[oldPlace].suffix = tmp;
                    }
                },
                selectedItems:[],
                clientSidePaging: true,
                pageSize:50,
                sortList : [],
                noSearch:true
            };


        }]
    };
});